import { Routes } from '@angular/router';
import { RoutesConstants } from 'src/app/shared/common';
import { Permissions } from 'src/app/core/common';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const REPORTS_ROUTES: Routes = [
  {
    path: RoutesConstants.TEACHERS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./teachers-report/pages/teachers-reports-page/teachers-reports-page.component').then(
        (x) => x.TeachersReportsPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'TEACHERS_REPORT',
        icon: 'man',
      },
      permissions: [Permissions.Reports_Teacher],
    },
  },
  {
    path: RoutesConstants.STUDENTS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./students-report/pages/students-report-page/students-report-page.component').then(
        (x) => x.StudentsReportPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'STUDENTS_REPORT',
        icon: 'school',
      },
      permissions: [Permissions.Reports_Student],
    },
  },
  // {
  //   path: RoutesConstants.CALLS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./calls-report/pages/calls-report-page/calls-report-page.component').then(
  //       (x) => x.CallsReportPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'CALLS_REPORT',
  //       icon: 'call',
  //     },
  //     permissions: [Permissions.Reports_Call],
  //   },
  // },
  // {
  //   path: RoutesConstants.CALLS_DETAILS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./calls-details-report/pages/calls-details-page/calls-details-page.component').then(
  //       (x) => x.CallsDetailsPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'CALLS_DETAILS_REPORT',
  //       icon: 'call',
  //     },
  //     permissions: [Permissions.Reports_Detailed_Call],
  //   },
  // },
  // {
  //   path: RoutesConstants.BLOCKED_STUDENTS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import(
  //       './blocked-students-report/pages/blocked-students-report-page/blocked-students-report-page.component'
  //     ).then((x) => x.BlockedStudentsReportPageComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'BLOCKED_STUDENTS_REPORT',
  //       icon: 'app_blocking',
  //     },
  //     permissions: [Permissions.Reports_Blocked_Student],
  //   },
  // },
  {
    path: RoutesConstants.TEACHERS_PERFORMANCE_REPORT_PAGE_URL,
    loadComponent: () =>
      import(
        './teachers-performance-report/pages/teachers-performance-report-page/teachers-performance-report-page.component'
      ).then((x) => x.TeachersPerformanceReportPageComponent),
    data: {
      breadcrumb: {
        label: 'TEACHERS_PERFORMANCE_REPORTS',
        icon: 'monitoring',
      },
      permissions: [Permissions.Reports_Performance_Teacher],
    },
  },
  {
    path: RoutesConstants.STUDENT_PERFORMANCE_REPORT_PAGE_URL,
    loadComponent: () =>
      import(
        './students-performance-report/pages/students-performance-report-page/students-performance-report-page.component'
      ).then((x) => x.StudentsPerformanceReportPageComponent),
    data: {
      breadcrumb: {
        label: 'STUDENT_PERFORMANCE_REPORTS',
        icon: 'monitoring',
      },
      permissions: [Permissions.Reports_Performance_Student],
    },
  },
  // {
  //   path: RoutesConstants.DEPENDENTS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./dependents-report/pages/dependents-report-page/dependents-report-page.component').then(
  //       (x) => x.DependentsReportPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'DEPENDENTS_REPORTS',
  //       icon: 'follow_the_signs',
  //     },
  //     permissions: [Permissions.Reports_Dependent],
  //   },
  // },
  {
    path: RoutesConstants.REVIEWS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./reviews-report/pages/reviews-report-page/reviews-report-page.component').then(
        (x) => x.ReviewsReportPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'REVIEWS_REPORTS',
        icon: 'reviews',
      },
      permissions: [Permissions.Reports_Reviews, Permissions.User_Management_Admin_Users_Customer_Service],
    },
  },
  // {
  //   path: RoutesConstants.REVIEWERS_REVIEWS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import(
  //       './reviewers-reviews-report/pages/reviewers-reviews-report-page/reviewers-reviews-report-page.component'
  //     ).then((x) => x.ReviewersReviewsReportPageComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'REVIEWERS_REVIEWS_REPORTS',
  //       icon: 'reviews',
  //     },
  //     permissions: [Permissions.Reports_Admin_Reviews],
  //   },
  // },
  {
    path: RoutesConstants.BALANCE_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./balance-report/pages/balance-reports-page/balance-reports-page.component').then(
        (x) => x.BalanceReportsPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'BALANCE_REPORT',
        icon: 'account_balance_wallet',
      },
      permissions: [Permissions.Reports_Student_Packages],
    },
  },
  {
    path: RoutesConstants.SESSIONS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./sessions-report/pages/sessions-report-page/sessions-report-page.component').then(
        (x) => x.SessionsReportPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'SESSIONS_REPORT',
        icon: 'assignment_turned_in',
      },
      permissions: [Permissions.Reports_Sessions],
    },
  },
  // {
  //   path: RoutesConstants.TEACHER_ONLINE_MINUTES_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import(
  //       './teacher-online-minutes-report/pages/online-teacher-minutes-report-page/online-teacher-minutes-report-page.component'
  //     ).then((x) => x.OnlineTeacherMinutesReportPageComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'TEACHER_ONLINE_MINUTES_REPORT',
  //       icon: 'wifi_notification',
  //     },
  //     permissions: [Permissions.Reports_OnlineMinutes_Teacher],
  //   },
  // },
  // {
  //   path: RoutesConstants.PEAK_HOURS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./peak-hours-report/pages/peak-hours-report-page/peak-hours-report-page.component').then(
  //       (x) => x.PeakHoursReportPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'PEAK_HOURS_REPORT',
  //       icon: 'stacked_line_chart',
  //     },
  //     permissions: [Permissions.Reports_PeakTime],
  //   },
  // },

  {
    path: RoutesConstants.MESSAGES_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./messages-report/pages/messages-report-page/messages-report-page.component').then(
        (x) => x.MessagesReportPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'MESSAGES_REPORT',
        icon: 'sms',
      },
      permissions: [Permissions.Reports_NotificationReport],
    },
  },
  {
    path: RoutesConstants.RESERVATIONS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./reservations-report/pages/reservations-report-page/reservations-report-page.component').then(
        (x) => x.ReservationsReportPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'RESERVATIONS_REPORT',
        icon: 'book_online',
      },
      permissions: [Permissions.Reports_Reservation],
    },
  },
  {
    path: RoutesConstants.PAY_TABS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./paytabs-report/pages/paytabs-report-page/paytabs-report-page.component').then(
        (x) => x.PaytabsReportPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'PAY_TABS_REPORT',
        icon: 'receipt_long',
      },
      permissions: [Permissions.Reports_PaymentTransaction],
    },
  },
  // {
  //   path: RoutesConstants.SURVEYS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./surveys-report/pages/surveys-report-page/surveys-report-page.component').then(
  //       (x) => x.SurveysReportPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'SURVEYS_REPORT',
  //       icon: 'mood',
  //     },
  //     permissions: [Permissions.Reports_Survey],
  //   },
  // },
  // {
  //   path: RoutesConstants.STORE_RATINGS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./store-rating-report/pages/store-rating-report-page/store-rating-report-page.component').then(
  //       (x) => x.StoreRatingReportPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'STORE_RATINGS_REPORT',
  //       icon: 'store',
  //     },
  //     permissions: [Permissions.Reports_App_Rating],
  //   },
  // },
  {
    path: RoutesConstants.STUDENT_DETAILS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./student-details-report/pages/student-details-page/student-details-page.component').then(
        (x) => x.StudentDetailsPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'STUDENT_DETAILS_REPORT',
        icon: 'info',
      },
      permissions: [Permissions.Reports_Student_Info],
    },
  },
  // {
  //   path: RoutesConstants.DONATIONS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./donations/pages/donations-page/donations-page.component').then((x) => x.DonationsPageComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'DONATIONS',
  //       icon: 'attach_money',
  //     },
  //     permissions: [Permissions.Reports_Donations],
  //   },
  // },
  // {
  //   path: RoutesConstants.BENEFICIARIES_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./beneficiaries-report/pages/beneficiaries-report/beneficiaries-report.component').then(
  //       (x) => x.BeneficiariesReportComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'BENEFICIARIES_REPORT',
  //       icon: 'supervised_user_circle',
  //     },
  //     permissions: [Permissions.Reports_Beneficiaries],
  //   },
  // },
  // {
  //   path: RoutesConstants.TOTAL_DURATION_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./total-duration-report/pages/total-duration-report/total-duration-report.component').then(
  //       (x) => x.TotalDurationReportComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'TOTAL_DURATION_REPORT',
  //       icon: 'access_time',
  //     },
  //     permissions: [Permissions.Reports_Total_Duration],
  //   },
  // },
  // {
  //   path: RoutesConstants.STUDENTS_PLANS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./students-plans-report/pages/student-plans-report/student-plans-report.component').then(
  //       (x) => x.StudentPlansReportComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'STUDENTS_PLANS_REPORT',
  //       icon: 'book',
  //     },
  //     permissions: [Permissions.Reports_Student_Plans],
  //   },
  // },
  {
    path: RoutesConstants.TEACHERS_PLANS_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./teachers-plans-report/pages/teachers-plans-report/teachers-plans-report.component').then(
        (x) => x.TeachersPlansReportComponent
      ),
    data: {
      breadcrumb: {
        label: 'TEACHERS_PLANS_REPORT',
        icon: 'library_books',
      },
      permissions: [Permissions.Reports_Teachers_plans],
    },
  },
  {
    path: RoutesConstants.TEACHER_RESERVATION_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./teacher-reservation-report/pages/teacher-reservation-report/teacher-reservation-report.component').then(
        (x) => x.TeacherReservationReportComponent
      ),
    data: {
      breadcrumb: {
        label: 'TEACHER_RESERVATION_REPORT',
        icon: 'book_online',
      },
      Permissions: [Permissions.Reports_Teacher_Reservation],
    },
  },
  {
    path: RoutesConstants.FREE_CODES_REPORT_PAGE_URL,
    loadComponent: () =>
      import('./free-codes-report/pages/free-codes-report/free-codes-report.component').then(
        (x) => x.FreeCodesReportComponent
      ),
    data: {
      permissions: [Permissions.Reports_Free_codes],
    },
  },
  // {
  //   path: RoutesConstants.FATIHA_SESSIONS_REPORT_PAGE_URL,
  //   loadComponent: () =>
  //     import('./fatiha-sessions/pages/fatiha-sessions/fatiha-sessions.component').then(
  //       (x) => x.FatihaSessionsComponent
  //     ),
  //   data: {
  //     permissions: [Permissions.Fatiha_Sessions],
  //   },
  // },
];

for (const route of REPORTS_ROUTES) {
  route.canActivate = [PermissionGuard];
}
